module.exports = "img/network-matrix.464d34e.svg";